module.exports = __webpack_public_path__ + "static/img/home_icon_getcode_2.c20bc2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/home_icon_getcode_2.png
// module id = 9Cn3
// module chunks = 0